<span class="badge gap-2 pe-2"
      [ngClass]="StatusClass[status]">
    <span [ngClass]="'goal-status-icon-without-circle-' + StatusClass[status].toLowerCase()"
          class="invert-color"></span>
    <span class="text-white">{{ statusText }}</span>
    @if (showCollapsible) {
        <span class="d-print-none">
            @if (isCollapsed) {
                <i class="fal fa-chevron-down"></i>
            }
            @if (!isCollapsed) {
                <i class="fal fa-chevron-up"></i>
            }
        </span>
    }
</span>
